import {
  CLEAR_MAP_CHARTS,
  FETCH_MAP_CHARTS_OVERVIEW_SUCCESS,
  FETCH_MAP_CHARTS_MANAGE_SUCCESS,
} from '../../../actions/pages/map-charts-page'

export function mapChartsPage(
  state = {
    overview: null,
    manage: null
  },
  action
) {
  switch (action.type) {
    case CLEAR_MAP_CHARTS: {
      return Object.assign({}, state, {
        overview: null,
        manage: null
      })
    }
    case FETCH_MAP_CHARTS_OVERVIEW_SUCCESS: {
      return Object.assign({}, state, {
        overview: action.overview
      })
    }
    case FETCH_MAP_CHARTS_MANAGE_SUCCESS: {
      return Object.assign({}, state, {
        manage: action.manage
      })
    }
    default:
      return state
  }
}
